import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { EmpresaModel } from 'model/api/gestao/master/empresa';
import { VariaveisAmbiente } from 'config';

export class IdentidadeNovoContratoProps {
    constructor(
        public nome: string = '',
        public email: string = '',
        public senha: string = '',
        public senhaConfirmacao: string = '',
        public apelido: string = '',
        public telefone: string = '',
        public sistemaId: string = '',
        public empresa: EmpresaModel = new EmpresaModel()
    ) { }
}

export function usePostIdentidadeNovoContrato() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIdentidadeNovoContrato = useCallback(
        (contratoProps: IdentidadeNovoContratoProps, chaveAtivacao: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Contrato`,
                method: 'POST',
                data: contratoProps,
                enviarTokenUsuario: false,
                headers: {
                    chaveAtivacao: chaveAtivacao
                },
                timeout: 60000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIdentidadeNovoContrato,
    };
}
